<template>
  <v-container class="pa-0 modern-bitacora">
    <div v-if="process.bitacora && process.bitacora.length > 0">
      <!-- Data Table Section -->
      <v-card outlined class="modern-card overflow-hidden elevation-0 mb-6">
        <v-simple-table class="modern-table">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left grey lighten-5">Fecha</th>
                <th class="text-left grey lighten-5">Usuario Operador</th>
                <th class="text-right grey lighten-5" width="120" v-if="process.machine.production_unit_m2">Metros²</th>
                <th class="text-right grey lighten-5" width="120" v-else>Cantidad</th>
                <th class="text-left grey lighten-5" width="200">Equipo Utilizado</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in process.bitacora" :key="item.id" class="hover-row">
                <td class="body-2 font-weight-medium grey--text text--darken-2">
                  {{item.created_at | moment("DD/MM/YYYY")}}
                  <div class="caption grey--text opacity-70">{{item.created_at | moment("HH:mm")}} hrs</div>
                </td>
                <td>
                  <div class="d-flex align-center">
                    <v-avatar size="24" color="grey lighten-4" class="mr-2">
                      <v-icon x-small color="grey darken-1">fas fa-user-gear</v-icon>
                    </v-avatar>
                    <span class="body-2">{{item.created_by.first_name}} {{item.created_by.last_name}}</span>
                  </div>
                </td>
                <td class="text-right">
                  <span v-if="process.machine.production_unit_m2" class="body-2 font-weight-black primary--text">
                    {{item.mts2 | number('0.00')}}
                  </span>
                  <span v-else class="body-2 font-weight-black primary--text">
                    {{item.qty | number('0.00')}}
                  </span>
                </td>
                <td>
                  <v-chip v-if="item.equipment" x-small label outlined color="primary" class="font-weight-bold">
                    <v-icon x-small left>fas fa-tools</v-icon>
                    {{item.equipment.name}}
                  </v-chip>
                  <span v-else class="caption font-italic grey--text">N/A</span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>

      <!-- Summary Card -->
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" md="4">
          <div class="pa-4 rounded-xl bg-primary-gradient shadow-sm text-right">
            <div class="white--text text-overline opacity-70 mb-1">Carga de Trabajo Registrada</div>
            <div class="white--text text-h4 font-weight-black">
              {{ process.machine.production_unit_m2 ? totalMts2 : totalQty | number('0.00') }}
              <span class="text-subtitle-2 opacity-80">{{ process.machine.production_unit_m2 ? 'M²' : 'Unidades' }}</span>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>

    <!-- Empty State -->
    <v-card v-else outlined class="modern-card pa-12 text-center grey--text lighten-2">
      <v-icon x-large class="mb-4 opacity-20">fas fa-clipboard-list</v-icon>
      <div class="text-subtitle-1 font-weight-bold grey--text">Sin registros en bitácora</div>
      <div class="caption grey--text opacity-70 mt-1">Aún no se ha reportado actividad para este proceso.</div>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'BitacoraDetails',
  props: ['process'],
  computed: {
    totalMts2() {
      if (!this.process.bitacora) return 0
      return this.process.bitacora.reduce((total, r) => total + parseFloat(r.mts2 || 0), 0)
    },
    totalQty() {
      if (!this.process.bitacora) return 0
      return this.process.bitacora.reduce((total, r) => total + parseFloat(r.qty || 0), 0)
    }
  }
}
</script>

<style scoped>
.modern-bitacora {
  max-width: 1000px;
  margin: 0 auto;
}
.modern-card {
  border: 1px solid rgba(0,0,0,0.08) !important;
  border-radius: 12px !important;
}
.bg-primary-gradient {
  background: linear-gradient(135deg, var(--v-primary-base) 0%, var(--v-primary-darken1) 100%) !important;
}
.opacity-10 { opacity: 0.1; }
.opacity-30 { opacity: 0.3; }
.opacity-70 { opacity: 0.7; }
.opacity-20 { opacity: 0.2; }
.lh-1-2 { line-height: 1.2; }
.modern-table thead th {
  font-size: 0.75rem !important;
  font-weight: 800 !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  height: 48px !important;
}
.hover-row:hover {
  background-color: rgba(var(--v-primary-base), 0.02);
}
.tracking-wider { letter-spacing: 1px; }
</style>